.PageContainer {
  width: 100vw;
  height: 100vh;

  .LogoutButton {
    position: absolute;
    top: 2.5rem;
    right: 1rem;
    z-index: 1000;
  }

  .DashboardButton {
    position: absolute;
    top: 2.5rem;
    right: 12rem;
    z-index: 1000;
  }

}

.Spinner {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.EtlImport {
  position: absolute;
  bottom: 0rem;
  left: 0.4rem;
  z-index: 1000;
  padding: 10px;

  display: flex;
  column-gap: 1rem;

  font-size: 1rem;
  font-weight: 600;
}
